const fieldValidation = {
  required: '{{fieldName}} は必須です',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
